import React, { useState, useContext } from 'react';
import Header from 'components/header/Header';
import { MainHeaderProps, ModalDetails } from 'business/models/CustomModels';
import ScreenExperimentWizard from '../screenExperimentWizard/ScreenExperimentWizard';
import BatchloadExperimentWizard from '../batchLoadExperimentWizard/BatchLoadExperimentWizard';
import RMModal from 'components/modal/RMModal';
import TreeContext from 'components/main/tree/TreeContext';
import './MainHeader.scss';
import useMainHeaderButtons, {
  useMainHeaderButtonsProps,
} from './Hooks/useMainHeaderButtons';
import useRMLite from 'CustomHooks/useRMLite';
export default function MainHeader(props: MainHeaderProps) {
  const { commonTreeNodes, selectedNodes, selectedParentNode, newFolderType } = props;

  const treeContext = useContext(TreeContext);
  const [showWizard, setShowWizard] = useState(false);
  const [wizardType, setWizardType] = useState('');
  const rmLite = useRMLite();

  const [modalDetails, setModalDetails] = useState<ModalDetails>({
    showModal: false,
    setShowModal: () => {},
    onOk: () => setModalDetails({ ...modalDetails, showModal: false }),
    body: <></>,
    heading: '',
    isOkOnly: true,
    okButtonText: 'OK',
    noButtonText: undefined,
    showButtons: false,
  });
  const headerButtonsProps: useMainHeaderButtonsProps = {
    groupBy: treeContext.groupBy,
    modalDetails,
    selectedParentNode,
    setGroupBy: treeContext.setGroupBy,
    setModalDetails,
    setShowWizard,
    setSortBy: treeContext.setSortBy,
    setViewType: treeContext.setViewType,
    setWizardType,
    rmLite,
    newFolderType,
    showFilter: true,
  };
  const headerButtons = useMainHeaderButtons(headerButtonsProps);

  function onClose() {
    setShowWizard(false);
  }

  return (
    <>
      {showWizard &&
        (wizardType == 'ScreenExperiment' ? (
          <ScreenExperimentWizard
            id={'mainheader-screen-wizard'}
            onClose={onClose}
            commonTreeNodes={commonTreeNodes}
            gSelectedNode={selectedNodes}
            selectedParentNode={selectedParentNode}
          />
        ) : (
          <BatchloadExperimentWizard onClose={onClose} />
        ))}
      <Header headerButtons={headerButtons} title={'Project'} isNewTheme={true} />
      <RMModal
        id="mainheader-modal"
        showModal={modalDetails.showModal}
        setShowModal={() => setModalDetails({ ...modalDetails, showModal: false })}
        onOk={modalDetails.onOk}
        body={modalDetails.body}
        heading={modalDetails.heading}
        okButtonText={modalDetails.okButtonText}
        isOkOnly={modalDetails.isOkOnly}
        okayDisabled={false}
        noButtonText={modalDetails.noButtonText}
        showButtons={modalDetails.showButtons}
      />
    </>
  );
}
